import { Component, Input, EventEmitter, Output, PLATFORM_ID, Inject, ElementRef, ViewChild} from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { MatDialogModule } from '@angular/material/dialog';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatProgressBarModule } from '@angular/material/progress-bar';

import { AnalysisOptionsComponent } from '../../tools/analysis-options/analysis-options.component';

import { HttpClient, HttpClientModule } from '@angular/common/http';
import { FacadeService } from '../../services/facade.service';

import { ProyectosService } from '../../services/proyectos.service';

//Variables del Navegador
type MenuItem = 'summary' | 'pof';

//Variable para expandir cada cuadro
interface ExpandedState {
  [key: string]: boolean;
}

interface WordCount {
  word: string;
  count: number;
}


@Component({
  selector: 'tagger',
  standalone: true,
  imports: [MatDialogModule,
    CommonModule,
    RouterOutlet,
    MatSidenavModule,
    MatExpansionModule,
    MatToolbarModule,
    MatIconModule,
    MatListModule,
    MatCardModule,
    MatButtonModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatMenuModule,
    MatSlideToggleModule,
    MatProgressBarModule,
    AnalysisOptionsComponent,
    HttpClientModule],
  templateUrl: './tagger.component.html',
  styleUrl: './tagger.component.css'
})



export class TaggerComponent {
  selectedMenuItem: MenuItem = 'pof';
  @Input() checked: boolean; //Variable del mat-slide-toggle del text-component

  @Output() textItemSelected = new EventEmitter<boolean>();

  loaderActive: boolean;
  loaderActive2: boolean;
  loaderActiveFirstProject: boolean;

  activeEyeIcon: HTMLImageElement | null = null;

  isIconRotated = false;

  verifyLoaderActive2: boolean;

  imgSrc: { [key: string]: string } = {};

  isScreenLarge: boolean = false;

  UpdateTagger: boolean = false;

  selectAllActive = false;

  //Valores para expandir cada Cuadro
  public isExpanded = {};

  //Dividir los datos obtenidos entre las 3 columnas al expandir la informacion

  public dividedData = {};
  project_data: any;
  public ishighlighted = {};
  public data_pof3 = {};
  palabraresaltada = {};
  respuestaWords: any[] = [
    { "value": "$", "descripcion": "currency symbol" },
    { "value": ",", "descripcion": "comma" },
    { "value": ":", "descripcion": "general joiner" },
    { "value": "???", "descripcion": "unknown token type" },
    { "value": "CD", "descripcion": "cardinal number" },
    { "value": "CO", "descripcion": "coordinating conjunction" },
    { "value": "DAT", "descripcion": "determiner, article" },
    { "value": "DT", "descripcion": "determiner" },
    { "value": "DTW", "descripcion": "wh-determiner" },
    { "value": "EX", "descripcion": "existential there" },
    { "value": "FW", "descripcion": "foreign word" },
    { "value": "GE", "descripcion": "possessive ending" },
    { "value": "IN", "descripcion": "preposition/subordinating conjunction" },
    { "value": "JJ", "descripcion": "adjective" },
    { "value": "JJR", "descripcion": "adjective, comparative" },
    { "value": "JJS", "descripcion": "adjective, superlative" },
    { "value": "LS", "descripcion": "list marker" },
    { "value": "MD", "descripcion": "modal" },
    { "value": "NN", "descripcion": "noun, singular or mass" },
    { "value": "NNS", "descripcion": "noun plural" },
    { "value": "NP", "descripcion": "proper noun, singular" },
    { "value": "NPS", "descripcion": "proper noun, plural" },
    { "value": "PDT", "descripcion": "predeterminer" },
    { "value": "PN", "descripcion": "pronoun neutral" },
    { "value": "PP", "descripcion": "personal pronoun" },
    { "value": "PP$", "descripcion": "possessive pronoun" },
    { "value": "PWH", "descripcion": "wh-pronoun" },
    { "value": "PWS", "descripcion": "possessive wh-pronoun" },
    { "value": "QQ", "descripcion": "particle" },
    { "value": "RB", "descripcion": "adverb" },
    { "value": "RBR", "descripcion": "adverb, comparative" },
    { "value": "RBS", "descripcion": "adverb, superlative" },
    { "value": "STOP", "descripcion": "end punctuation" },
    { "value": "SYM", "descripcion": "symbol" },
    { "value": "THAT", "descripcion": "complementizer" },
    { "value": "TO", "descripcion": "to" },
    { "value": "UH", "descripcion": "interjection" },
    { "value": "VB", "descripcion": "verb be, base form" },
    { "value": "VBD", "descripcion": "verb be, past" },
    { "value": "VBG", "descripcion": "verb be, gerund/participle" },
    { "value": "VBN", "descripcion": "verb be, past participle" },
    { "value": "VBP", "descripcion": "verb be, present non-3rd person" },
    { "value": "VBZ", "descripcion": "verb be, present 3rd person singular" },
    { "value": "VD", "descripcion": "verb do, base form" },
    { "value": "VDD", "descripcion": "verb do, past" },
    { "value": "VDG", "descripcion": "verb do, gerund/participle" },
    { "value": "VDN", "descripcion": "verb do, past participle" },
    { "value": "VDP", "descripcion": "verb do, present non-3rd person" },
    { "value": "VDZ", "descripcion": "verb do, present 3rd person singular" },
    { "value": "VH", "descripcion": "verb have, base form" },
    { "value": "VHD", "descripcion": "verb have, past" },
    { "value": "VHG", "descripcion": "verb have, gerund/participle" },
    { "value": "VHN", "descripcion": "verb have, past participle" },
    { "value": "VHP", "descripcion": "verb have, present non-3rd person" },
    { "value": "VHZ", "descripcion": "verb have, present 3rd person singular" },
    { "value": "VV", "descripcion": "verb, base form" },
    { "value": "VVD", "descripcion": "verb, past tense" },
    { "value": "VVG", "descripcion": "verb, gerund/participle" },
    { "value": "VVN", "descripcion": "verb, past participle" },
    { "value": "VVP", "descripcion": "verb, present non-3rd person" },
    { "value": "VVZ", "descripcion": "verb, present 3rd person singular" },
    { "value": "WRB", "descripcion": "wh-adverb" },
    { "value": "XX", "descripcion": "negative particle" }
  ];

  cambios_de_palabras = []

  divideData() {
    for (const key in this.data_pof) {
      if (this.data_pof.hasOwnProperty(key)) {
        const items = this.data_pof[key];
        const chunkSize = Math.ceil(items.length / 3);
        this.dividedData[key] = [
          items.slice(0, chunkSize),
          items.slice(chunkSize, chunkSize * 2),
          items.slice(chunkSize * 2),
        ];
      }
    }
  }

  onResize() {
    this.isScreenLarge = window.innerWidth > 1000;
  }


  // Variables de la pagina de Summary
  public pof = {}
  public data_pof: any = {}
  public summary = {
    coverage: {
      total: null,
      counted: null,
      not_counted: null,
    },
    tokens: null,
    types: null,
    tokens_known: null,
    types_known:null,
    elements: null,
    type_token: null,
    tokens_per_type: null,
    total_verbal: null,
    verbal_elements: null,
    total_noun: null,
    noun_elements: null,
  };
  private proyectoSub;

  public hideEyeIconsForSafari1561 = false;

  constructor(
    // private menuService: MenuService
    private http: HttpClient,
    public fachada: FacadeService,
    public proyectoService: ProyectosService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.checked = true;
  }

  ngOnInit(): void {
    localStorage.setItem("actual","tagger")
    this.isButtonDisabled();
    this.hideEyeIconsForSafari1561 = false;
    if (isPlatformBrowser(this.platformId)) {
      this.isScreenLarge = window.innerWidth > 1000;
      window.addEventListener('resize', this.onResize.bind(this));
    }
    this.initSubscribe();
     if(sessionStorage.getItem("id_project")){
    this.initTagger();
     }
    if(sessionStorage.getItem("text_UID")){
      this.loaderActive = true;
    }
     this.proyectoService.loader$.subscribe(loader => {
      if(this.loaderActive2){
        this.loaderActive = false;
      }else{
        this.loaderActive = loader;
      }
    });

        this.proyectoService.loaderAnalyzing$.subscribe(loader => {
      if(loader){
        this.loaderActive2 = true;
      }
      if(!loader){
        this.loaderActive2 = false;
      }
    });

         this.proyectoService.loaderCreatingProject$.subscribe(value => {
      if(value){
        this.loaderActive2 = true;
      }
      if(!value){
        this.loaderActive2 = false;
      }
    });

        // **Inicializar correctamente el estado de los ojos**
        Object.keys(this.data_pof3).forEach(categoria => {
          this.isEyeOn[categoria] = false; // Todas inician apagadas
        });
    
        this.categoriasActivas.clear(); // Limpiar selección inicial
    
       // **Inicializar correctamente el estado de los ojos**
        Object.keys(this.data_pof3).forEach(categoria => {
            this.isEyeOn[categoria] = false; // Todas las categorías inician apagadas
        });
    
        this.categoriasActivas.clear(); // Limpiar selección inicial
    
        // **Forzar "See All" a estar apagado al inicio**
        this.seeAllActive = false;
        this.seeAllIconSrc = '../../assets/images/eye-icon.svg';
    
            this.proyectoService.verifyloaderAnalyzing$.subscribe(value => {
      if(value){
        this.verifyLoaderActive2 = true;
      }
      if(!value){
        this.verifyLoaderActive2 = false;
      }
    });


     setInterval(() => {
       let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "tagger" && sessionStorage.getItem("tagger") !== "-" && !this.loaderActive && sessionStorage.getItem("id_project") && !this.verifyLoaderActive2){
       this.loaderActive2 = false;
          this.loaderActive = false;
          this.loaderActiveFirstProject = false;
          this.proyectoService.updateloader(false);
          this.initTagger()
      }
      }, 20 * 1000); // 30 segundos
    
  }

  initSubscribe() {
    if (!this.proyectoSub || this.proyectoSub.closed) {
      //Subscribimos al servicio para escuchar los datos
      this.proyectoSub = this.proyectoService.proyecto$.subscribe(({ proyecto, firstProject }) => {
         if(!firstProject){
            this.loaderActive = false;
            if(sessionStorage.getItem("text_UID")){
              if(!this.loaderActiveFirstProject){
              this.loaderActive2 = true;
            }
            }else{
              this.loaderActive2 = false;
            }
          }
          if(firstProject){
            this.loaderActive = false;
            if(sessionStorage.getItem("text_UID")){
              this.loaderActiveFirstProject = true;
            }else{
              this.loaderActiveFirstProject = false;
            }
          }
        console.log("Updatededata--Reporta: Tagger--")
        this.project_data = proyecto;
  
  
        // Apagar todas las palabras resaltadas
        Object.keys(this.palabraresaltada).forEach(categoria => {
          Object.keys(this.palabraresaltada[categoria]).forEach(palabra => {
              this.palabraresaltada[categoria][palabra] = false;
          });
        });
  
        // Apagar todos los ojos de verPalabra
        Object.keys(this.palabraSeleccionada).forEach(key => {
          this.palabraSeleccionada[key] = false;
        });
  
         // **Apagar todas las palabras resaltadas activadas por toggleEyeIconPalabra**
        Object.keys(this.palabraresaltada).forEach(categoria => {
          Object.keys(this.palabraresaltada[categoria]).forEach(palabraResaltada => {
            this.palabraresaltada[categoria][palabraResaltada] = false;
          });
        });
  
        // Apagar ojos
        Object.keys(this.isEyeOn).forEach(categoria => {
          this.isEyeOn[categoria] = false;
        });
  
        this.categoriasActivas.clear();
        this.seeAllActive = false;
        this.seeAllIconSrc = '../../assets/images/eye-icon.svg';
  
        this.proyectoService.undoMarcadoMultiple(this.http);
  
        
        if(sessionStorage.getItem("id_project")){
  
        this.initTagger();
        }
      });
    }
  }
  status: any;
  async initTagger() {
     let pantalla_actual = localStorage.getItem("actual")
    if (pantalla_actual == "tagger"){
      // Intentar recuperar el resumen desde sessionStorage
      const memoryStorage = sessionStorage.getItem("tagger");
  
      if (memoryStorage && !this.UpdateTagger) {
         if(memoryStorage !== "-"){
        try {
          // Si existe, convertirlo de JSON string a objeto y asignarlo
          let respuesta = JSON.parse(memoryStorage);
          this.summary = respuesta.summary;
          this.pof = respuesta.partsOfSpeech;
          this.data_pof = { }
  
          for (const key in respuesta.taggeddata) {
            this.data_pof[key] = {};
            this.data_pof3[key] = {};
            for (const palabra in respuesta.taggeddata[key]) {
                this.data_pof[key][palabra] = respuesta.taggeddata[key][palabra].count;
                this.data_pof3[key][palabra] = respuesta.taggeddata[key][palabra].position;
  
            }
        }
          // Inicializamos el objeto Is expanded para que coincida con lo que trae el middleware
          for (const key in this.pof) {
            this.isExpanded[key] = this.isExpanded[key] ?? false
            this.ishighlighted[key] = this.ishighlighted[key] ?? false
            const previousWordHighlights = this.palabraresaltada[key] ?? {}
            this.palabraresaltada[key] = {}
            for (const palbra in this.data_pof[key.toUpperCase()]) {
              this.palabraresaltada[key][palbra] = previousWordHighlights[palbra] ?? false
            }
          }
          // this.divideData();
        } catch (error) {
          console.log("Error en la petición de datos")
          console.log(error)
          sessionStorage.removeItem('tagger');
        }finally{
          this.loaderActive2 = false;
          this.loaderActive = false;
          this.loaderActiveFirstProject = false;
          this.proyectoService.updateloader(false);
  
        }
      }
      }
      if(!memoryStorage || this.UpdateTagger){
        sessionStorage.setItem("tagger", "-");
        //Tenemos que esperar unos milisegundos en lo que el servicio actualiza la info
        await new Promise(resolve => setTimeout(resolve, 10));
        try {
          let textUID = sessionStorage.getItem('text_UID');
          let respuesta = await this.fachada.getTaggerOfProject(this.http, textUID, "");
          // Guardar la respuesta en sessionStorage
          sessionStorage.setItem("tagger", JSON.stringify(respuesta));
          this.summary = respuesta.summary;
          this.pof = respuesta.partsOfSpeech;
          this.data_pof = { }
  
          for (const key in respuesta.taggeddata) {
            this.data_pof[key] = {};
            this.data_pof3[key] = {};
            for (const palabra in respuesta.taggeddata[key]) {
                this.data_pof[key][palabra] = respuesta.taggeddata[key][palabra].count;
                this.data_pof3[key][palabra] = respuesta.taggeddata[key][palabra].position;
  
            }
        }
          // Inicializamos el objeto Is expanded para que coincida con lo que trae el middleware
          for (const key in this.pof) {
            this.isExpanded[key] = this.isExpanded[key] ?? false
            this.ishighlighted[key] = this.ishighlighted[key] ?? false
            const previousWordHighlights = this.palabraresaltada[key] ?? {}
            this.palabraresaltada[key] = {}
            for (const palbra in this.data_pof[key.toUpperCase()]) {
              this.palabraresaltada[key][palbra] = previousWordHighlights[palbra] ?? false
            }
          }
          this.status = 200
          // this.divideData();
        } catch (error) {
           if (error?.status === 0) {
            console.error("Error 500: Error interno del servidor (tagger)");
            sessionStorage.removeItem('tagger');
            this.status = 0

          } else {
            console.log("Otro error en la petición de datos")
            console.log(error)
            sessionStorage.removeItem('tagger');
          }
          this.status = error?.status;
        }finally{
          if(this.status === 0){
            this.loaderActive2 = true;
            this.loaderActive = true;
            this.loaderActiveFirstProject = true;
            this.proyectoService.updateloader(true);
            this.UpdateTagger = true;
            setTimeout(() => {
              this.initTagger();
            }, 100);
          }else{  
            this.loaderActive2 = false;
            this.loaderActive = false;
            this.loaderActiveFirstProject = false;
            this.proyectoService.updateloader(false);
            this.UpdateTagger = false;
             setTimeout(() => {
              this.initTagger();
            }, 100);
          }
          
          
  
        }
      }
      }else{
      console.log(`tagger no es la pantalla actual así que bloqueamos peticiones`)
    }
    //DUDAS: de donde sale el (437 known) de Tokens (total items), ya que no lo veo en lo que me regresa la API de TEXT, lo mismo con Types (unique items)// Posiblemente sea una suma de todos los proyectos
  }

  public isSafariVersion1561(): boolean {
    const ua = navigator.userAgent;
    const safariMatch = ua.match(/Version\/([\d.]+) Safari\//);
    const isSafari = ua.includes("Safari") && ua.includes("Macintosh") && !ua.includes("Chrome");

    if (safariMatch && safariMatch[1] && isSafari) {
      return safariMatch[1] === "15.6.1";
    }

    return false;
  }

  getObjectKeys(obj: any): string[] {
    const keys = Object.keys(obj || {});

    if (obj !== this.pof) {
      return keys;
    }

    return keys.sort((a, b) => {
      const aEmpty = this.isCategoryEmpty(a);
      const bEmpty = this.isCategoryEmpty(b);
      return Number(aEmpty) - Number(bEmpty);
    });
  }

  toggleIcon() {
    this.isIconRotated = !this.isIconRotated;
  }

  resetIcon() { this.isIconRotated = false; }

  //Funcion para expandir cada cuadro
  toggleExpand(identifier: string) {
    if (!this.isCategoryInteractive(identifier)) {
      return;
    }
    this.isExpanded[identifier] = !this.isExpanded[identifier];
  }

  toggleExpandAll() {
    const interactiveCategories = this.getInteractiveCategories();

    if (!interactiveCategories.length) {
      return;
    }

    const allExpanded = interactiveCategories.every(identifier => this.isExpanded[identifier]);
    interactiveCategories.forEach(identifier => {
      this.isExpanded[identifier] = !allExpanded;
    });
  }
  
  showAll: boolean = true;

  isCategoryInteractive(identifier: string): boolean {
    const categoryData = this.pof?.[identifier];
    return Number(categoryData?.tokens ?? 0) > 0 || Number(categoryData?.uniqueTokens ?? 0) > 0;
  }

  private isCategoryEmpty(identifier: string): boolean {
    const categoryData = this.pof?.[identifier];
    return Number(categoryData?.tokens ?? 0) === 0 && Number(categoryData?.uniqueTokens ?? 0) === 0;
  }

  hasInteractiveCategories(): boolean {
    return this.getInteractiveCategories().length > 0;
  }

  areAllInteractiveCategoriesExpanded(): boolean {
    const interactiveCategories = this.getInteractiveCategories();
    return interactiveCategories.length > 0
      && interactiveCategories.every(identifier => this.isExpanded[identifier]);
  }

  private getInteractiveCategories(): string[] {
    return Object.keys(this.pof || {}).filter(identifier => this.isCategoryInteractive(identifier));
  }
  
  
  
  
  
  
  

  selectMenuItem(menuItem: MenuItem) {
    this.selectedMenuItem = menuItem;
    if (menuItem === 'summary') {
      this.textItemSelected.emit(true);
    } else {
      this.textItemSelected.emit(false);
    }
  }

  isSelected(menuItem: MenuItem): boolean {
    return this.selectedMenuItem === menuItem;
  }

  ponerOjo(event: MouseEvent, categoria: string, palabra: string): void {
    const element = event.currentTarget as HTMLElement;

    // Cambiar el fondo del contenedor
    element.style.background = "#FAE29E";

    // Mostrar los íconos
    const eyeIcons = element.querySelectorAll('.icon-eye');

    eyeIcons.forEach((icon) => {
      (icon as HTMLElement).style.visibility = "visible";
    });

  }

  quitarOjo(event: MouseEvent, categoria: string, palabra: string): void {
    const element = event.currentTarget as HTMLElement;

    // Restaurar el fondo del contenedor
    element.style.background = "transparent";

    // Ocultar los íconos
    const eyeIcons = element.querySelectorAll('.icon-eye');

   

  }

  selectedWord: { [key: string]: string | null } = {};

  selectWord(category: string, word: string): void {
    
    // Resetear todas las selecciones en otras categorías
    for (const cat in this.selectedWord) {
      if (cat !== category) {
        this.selectedWord[cat] = null;
      }
    }
  
    // Seleccionar la nueva palabra en la categoría actual
    this.selectedWord[category] = word;
  }


  async resetCategoryView(category: string) {
    console.log("No se realizaron cambios en la selección.");
    this.selectedWord[category] = null;
  }

  async updateCategory(category: string) {
    // Si no hay cambios en la selección, no hacemos nada
  if (this.cambios_de_palabras.length === 0) {
    console.log("No se realizaron cambios en la selección.");
    this.selectedWord[category] = null;
  }else{
      this.UpdateTagger = true;
      this.selectedWord[category] = null; // Resetea la selección para mostrar la lista completa
      console.log("Cambios detectados");
      await this.cambios_de_palabras.sort((a, b) => a.position - b.position);
      let data = {
        "palabras": this.cambios_de_palabras
      }
      await this.fachada.UpdateTaggerWordCategory(this.http, sessionStorage.getItem('text_UID'), data)
      this.cambios_de_palabras = [];
      this.initTagger()
      setTimeout(() => {
        this.proyectoService.undoMarcadoMultiple(this.http);
        this.seeAllIconSrc = '../../assets/images/eye-icon.svg';
        Object.keys(this.isEyeOn).forEach(categoria => {
          this.isEyeOn[categoria] = false;
        });
        Object.keys(this.palabraresaltada).forEach(categoria => {
          Object.keys(this.palabraresaltada[categoria]).forEach(palabraResaltada => {
            this.palabraresaltada[categoria][palabraResaltada] = false;
          });
          Object.keys(this.palabraSeleccionada).forEach(key => {
            this.palabraSeleccionada[key] = false;
          });
        });
      }, 1000);
    }
  }


  seeAllHighlighted: boolean = false; // Controla el estado del botón "See All"
seeAllIconSrc: string = '../../assets/images/eye-icon.svg'; //

isEyeOn: { [key: string]: boolean } = {};
categoriasActivas: Set<string> = new Set();
palabraSeleccionada: { [key: string]: boolean } = {};
seeAllActive: boolean = false;

verPalabra(palabra: string, categoria: string, index: number, desdeOjo: boolean = true): void {
  const categoriaUpper = categoria.toUpperCase();
  const key = `${categoriaUpper}-${palabra}-${index}`;

  // Apagar todos los ojos activados por toggleEyeIcon
  Object.keys(this.isEyeOn).forEach(categoria => {
    this.isEyeOn[categoria] = false;
  });
  this.categoriasActivas.clear();
  this.seeAllActive = false;
  this.seeAllIconSrc = '../../assets/images/eye-icon.svg';


  // Verificar si la categoría existe
  if (!this.data_pof3[categoriaUpper]) {
    console.error(`No se encontró la categoría "${categoriaUpper}".`);
    return;
  }

  // Verificar si la palabra existe dentro de la categoría
  const palabraData = this.data_pof3[categoriaUpper]?.[palabra];

  if (!palabraData || !Array.isArray(palabraData) || palabraData.length === 0) {
    console.error(`No se encontró la palabra "${palabra}" en la categoría "${categoriaUpper}" o no tiene posiciones válidas.`);
    return;
  }


  // Si el ojo está encendido y lo presionas, se apaga
  if (desdeOjo && this.palabraSeleccionada[key]) {
    this.palabraSeleccionada[key] = false;
    this.proyectoService.undoMarcadoMultiple(this.http);
    return;
  }

  // **Apagar todas las palabras resaltadas activadas por toggleEyeIconPalabra**
  Object.keys(this.palabraresaltada).forEach(categoria => {
    Object.keys(this.palabraresaltada[categoria]).forEach(palabraResaltada => {
      this.palabraresaltada[categoria][palabraResaltada] = false;
    });
  });

  // Primero apagamos todas las palabras antes de encender una nueva (excepto si es el mismo ojo)
  Object.keys(this.palabraSeleccionada).forEach(k => {
    this.palabraSeleccionada[k] = false;
  });

  // Encender la palabra seleccionada
  this.palabraSeleccionada[key] = true;

  // Recopilar posiciones de la palabra en la categoría seleccionada
  const posicionesSeleccionadas: { posicion: number; categoria: string }[] = palabraData.map(pos => ({
    posicion: pos,
    categoria: categoriaUpper
  }));


  // Verificar que el índice solicitado es válido
  if (index < 0 || index >= posicionesSeleccionadas.length) {
    console.error(`Índice fuera de rango: ${index}`);
    return;
  }

  // Obtener la posición específica de la palabra seleccionada en la categoría
  const posicionSeleccionada = posicionesSeleccionadas[index].posicion;


  // Recopilar posiciones de todas las categorías
  const posicionesOtrasCategorias: { posicion: number; categoria: string }[] = [];
  Object.keys(this.data_pof3).forEach(key => {
    if (key !== categoriaUpper) {
      const palabraEnCategoria = this.data_pof3[key]?.[palabra];
      if (palabraEnCategoria && Array.isArray(palabraEnCategoria) && palabraEnCategoria.length > 0) {
        palabraEnCategoria.forEach(pos => {
          posicionesOtrasCategorias.push({ posicion: pos, categoria: key });
        });
      }
    }
  });


  // Combinar todas las posiciones
  const todasLasPosiciones = [...posicionesSeleccionadas, ...posicionesOtrasCategorias];

  // Ordenar todas las posiciones de menor a mayor
  todasLasPosiciones.sort((a, b) => a.posicion - b.posicion);


  // Determinar el orden de la palabra seleccionada en el texto
  const ordenSeleccionado = todasLasPosiciones.findIndex(
    posObj => posObj.categoria === categoriaUpper && posObj.posicion === posicionSeleccionada
  );

  if (ordenSeleccionado !== -1) {

    this.proyectoService.resaltarCoincidenciaOrdenadaTagger(
      palabra,
      categoriaUpper,
      todasLasPosiciones,
      ordenSeleccionado + 1, // Empieza en 1
      this.http
    );
  } else {
    console.log(`No se encontró orden válido para la posición ${posicionSeleccionada} en la categoría "${categoriaUpper}".`);
  }
}

toggleEyeIcon(data: string): void {
  const categoriaUpper = data.toUpperCase();

  if (!this.isCategoryInteractive(data)) {
    return;
  }

  if (!this.data_pof3[categoriaUpper]) {
    console.error(`No se encontró la categoría "${categoriaUpper}".`);
    return;
  }
  // Apagar todos los ojos de verPalabra
  Object.keys(this.palabraSeleccionada).forEach(key => {
    this.palabraSeleccionada[key] = false;
  });

  const estadoActual = this.isEyeOn[categoriaUpper] || false;

  if (estadoActual) {
    this.categoriasActivas.delete(categoriaUpper);
    this.isEyeOn[categoriaUpper] = false;

    // Si "See All" estaba activo y desactivamos una categoría, apagamos solo el botón sin resetear todo
    if (this.seeAllActive) {
      this.seeAllActive = false;
    }

    // Si era la única categoría activa, llamar `undoMarcadoMultiple()`
    if (this.categoriasActivas.size === 0) {
      this.proyectoService.undoMarcadoMultiple(this.http);
    } else {
      this.actualizarResaltadoTexto();
    }
  } else {
    this.categoriasActivas.add(categoriaUpper);
    this.isEyeOn[categoriaUpper] = true;

    // **Apagar todos los ojos de las palabras**
    Object.keys(this.palabraresaltada).forEach(categoria => {
      Object.keys(this.palabraresaltada[categoria]).forEach(palabra => {
        this.palabraresaltada[categoria][palabra] = false;
      });
    });

    this.actualizarResaltadoTexto();
  }

  // Solo activar "See All" si todas las categorías están prendidas
  const allOn = Object.keys(this.data_pof3).every(categoria => this.isEyeOn[categoria]);
  this.seeAllActive = allOn;
  this.seeAllIconSrc = allOn
      ? '../../assets/images/yellow_icons/eye-on-icon.svg'
      : '../../assets/images/eye-icon.svg';
}



// Método para actualizar el resaltado en el texto considerando solo las categorías activas
actualizarResaltadoTexto(): void {
  let posicionesGlobales: { categoria: string; palabra: string; posicion: number }[] = [];

  // Recorrer todas las categorías disponibles para capturar todas las coincidencias
  Object.keys(this.data_pof3).forEach(categoria => {
      Object.keys(this.data_pof3[categoria]).forEach(palabra => {
          this.data_pof3[categoria][palabra].forEach(posicion => {
              posicionesGlobales.push({ categoria, palabra, posicion });
          });
      });
  });

  // Ordenar todas las posiciones de acuerdo con su aparición en el texto
  posicionesGlobales.sort((a, b) => a.posicion - b.posicion);

  // Mapear palabras con su posición y la categoría más relevante
  let posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[] } = {};

  posicionesGlobales.forEach(({ categoria, palabra, posicion }) => {
      if (!posicionesPorPalabra[palabra]) {
          posicionesPorPalabra[palabra] = [];
      }
      posicionesPorPalabra[palabra].push({ posicion, categoria });
  });

  // Condición para manejar una categoría seleccionada vs. múltiples categorías activas
  if (this.categoriasActivas.size === 1) {
      // Caso de una sola categoría activa: aplicar lógica específica
      const categoriaUnica = [...this.categoriasActivas][0];
      this.proyectoService.resaltarMultiplesCoincidenciasCategoriaTagger(
          Object.keys(this.data_pof3[categoriaUnica]),
          categoriaUnica,
          posicionesPorPalabra,this.http
      );
  } else {
      // Caso de múltiples categorías activas: aplicar resaltado estándar
      let posicionesFiltradas: { [key: string]: { posicion: number; categoria: string }[] } = {};

      // Filtrar posiciones por categorías activas y ordenar por posición
      Object.keys(posicionesPorPalabra).forEach(palabra => {
          // Filtrar solo las posiciones de las categorías activas
          posicionesFiltradas[palabra] = posicionesPorPalabra[palabra]
              .filter(({ categoria }) => this.categoriasActivas.has(categoria))
              // Ordenar las posiciones por su valor 'posicion'
              .sort((a, b) => a.posicion - b.posicion);
      });
      this.proyectoService.aplicarResaltadoTagger(posicionesFiltradas,this.http);
  }
}

toggleEyeIconPalabra(data: string, palabra: string): void {
  try {
    const categoriaUpper = data.toUpperCase();

    if (!this.data_pof3[categoriaUpper] || !this.data_pof3[categoriaUpper][palabra]) {
      console.error(`No se encontró la palabra "${palabra}" en la categoría "${categoriaUpper}".`);
      return;
    }

    // Inicialización defensiva
    if (!this.palabraresaltada[categoriaUpper]) {
      console.warn(`Inicializando palabraresaltada[${categoriaUpper}]`);
      this.palabraresaltada[categoriaUpper] = {};
    }

    if (!(palabra in this.palabraresaltada[categoriaUpper])) {
      console.warn(`Inicializando palabraresaltada[${categoriaUpper}][${palabra}]`);
      this.palabraresaltada[categoriaUpper][palabra] = false;
    }

    const estadoActual = this.palabraresaltada[categoriaUpper][palabra];

    if (estadoActual) {
      this.palabraresaltada[categoriaUpper][palabra] = false;
      this.proyectoService.undoMarcado([palabra], categoriaUpper);
      return;
    }

    // Apagar todas las palabras resaltadas en todas las categorías
    Object.keys(this.palabraresaltada).forEach(categoria => {
      Object.keys(this.palabraresaltada[categoria]).forEach(palabraResaltada => {
        this.palabraresaltada[categoria][palabraResaltada] = false;
      });
    });

    // Apagar ojos
    Object.keys(this.isEyeOn).forEach(categoria => {
      this.isEyeOn[categoria] = false;
    });

    this.categoriasActivas.clear();
    this.seeAllActive = false;
    this.seeAllIconSrc = '../../assets/images/eye-icon.svg';

    // Limpiar palabraSeleccionada
    Object.keys(this.palabraSeleccionada).forEach(key => {
      this.palabraSeleccionada[key] = false;
    });

    // Organizar posiciones globales
    let posicionesGlobales: { categoria: string; palabra: string; posicion: number }[] = [];

    Object.keys(this.data_pof3).forEach(categoria => {
      Object.keys(this.data_pof3[categoria]).forEach(palabra => {
        this.data_pof3[categoria][palabra].forEach(posicion => {
          posicionesGlobales.push({ categoria, palabra, posicion });
        });
      });
    });

    posicionesGlobales.sort((a, b) => a.posicion - b.posicion);

    let posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[] } = {};

    posicionesGlobales.forEach(({ categoria, palabra, posicion }) => {
      if (!posicionesPorPalabra[palabra]) {
        posicionesPorPalabra[palabra] = [];
      }
      posicionesPorPalabra[palabra].push({ posicion, categoria });
    });

    this.palabraresaltada[categoriaUpper][palabra] = true;

    this.proyectoService.resaltarMultiplesCoincidenciasTagger([palabra], categoriaUpper, posicionesPorPalabra,this.http);

  } catch (error) {
    console.error('Error dentro de toggleEyeIconPalabra:', error);
  }
}


toggleSeeAll(): void {
  if (!this.hasInteractiveCategories()) {
    return;
  }

  const allOn = !this.seeAllActive; // Invertir el estado actual

// Apagar todas las palabras resaltadas
Object.keys(this.palabraresaltada).forEach(categoria => {
  Object.keys(this.palabraresaltada[categoria]).forEach(palabra => {
      this.palabraresaltada[categoria][palabra] = false;
  });
});

// Apagar todos los ojos de verPalabra
Object.keys(this.palabraSeleccionada).forEach(key => {
  this.palabraSeleccionada[key] = false;
});


  
  // **Actualizar el estado de cada categoría correctamente**
  Object.keys(this.data_pof3).forEach(categoria => {
      this.isEyeOn[categoria] = allOn;
      if (allOn) {
          this.categoriasActivas.add(categoria);
      } else {
          this.categoriasActivas.delete(categoria);
      }

  });

  // Actualizar el estado del botón "See All"
  this.seeAllActive = allOn;
  this.seeAllIconSrc = allOn
      ? '../../assets/images/yellow_icons/eye-on-icon.svg'
      : '../../assets/images/eye-icon.svg';

  if (allOn) {
      // Resaltar todas las categorías
      let posicionesGlobales: { categoria: string; palabra: string; posicion: number }[] = [];

      Object.keys(this.data_pof3).forEach(categoria => {
          Object.keys(this.data_pof3[categoria]).forEach(palabra => {
              this.data_pof3[categoria][palabra].forEach(posicion => {
                  posicionesGlobales.push({ categoria, palabra, posicion });
              });
          });
      });

      posicionesGlobales.sort((a, b) => a.posicion - b.posicion);

      let posicionesPorPalabra: { [key: string]: { posicion: number; categoria: string }[] } = {};

      posicionesGlobales.forEach(({ categoria, palabra, posicion }) => {
          if (!posicionesPorPalabra[palabra]) {
              posicionesPorPalabra[palabra] = [];
          }
          posicionesPorPalabra[palabra].push({ posicion, categoria });
      });

      this.proyectoService.resaltarTodasLasCategoriasTagger(posicionesPorPalabra,this.http);
  } else {
      // Solo ejecutar `undoMarcadoMultiple()` cuando "See All" estaba activado y ahora se apaga
      this.proyectoService.undoMarcadoMultiple(this.http);
  }
}


  export_detallado() {
    let respaldo_ID = document.getElementById("PROJECT_ID_RESPALDO") as HTMLInputElement
    if (respaldo_ID) {
      if (respaldo_ID.value != '' && respaldo_ID.value != null) {
        this.fachada.detail_export("tagger", respaldo_ID.value)
      } else {
        alert("No hay proyecto cargado")
      }
    } else {
      alert("No esta en la página principal")
    }
  }

  export_tagger() {
    let respaldo_ID = document.getElementById("PROJECT_ID_RESPALDO") as HTMLInputElement
    if (respaldo_ID) {
      if (respaldo_ID.value != '' && respaldo_ID.value != null) {
        this.fachada.tagger_export("tagger", respaldo_ID.value)
      } else {
        alert("No hay proyecto cargado")
      }
    } else {
      alert("No esta en la página principal")
    }
  }

  isButtonDisabled(): boolean {
    return !sessionStorage.getItem("text_UID"); 
  }

  encontrarCantidad(palabra, categoria){
    categoria = categoria.toUpperCase()
    return this.data_pof[categoria][palabra];
  }

  isWordSelected(valor, categoria, item){
    return (valor == categoria.toUpperCase())
  }

  async onSelectionRadioChange(palabra, position, origen, categoria, description) {
    let data = {
      "palabra":palabra,
      "origen": origen.toUpperCase(),
      "new_category": categoria.toUpperCase(),
      "position": position,
      "description": description
    }
    let editado = false
    for (let index = 0; index < this.cambios_de_palabras.length; index++) {
      let element = this.cambios_de_palabras[index];
      if (element.position == data.position){
        editado = true
        this.cambios_de_palabras[index] = data;
        break
      }
    }
    if (!editado){
      this.cambios_de_palabras.push(data)
    }
    this.proyectoService.undoMarcadoMultiple(this.http);
    // console.log(data);
  }

}
